import React, { useEffect, useState } from 'react';

const Weather = () => {
  const [weatherData, setWeatherData] = useState(null);
  const city = 'İstanbul'; 

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=f5d3876c9d8b53489f85c819b24ae77c`);
        const data = await response.json();
        setWeatherData(data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [city]);

  if (!weatherData) {
    return <div>Loading...</div>;
  }

  const temperatureCelsius = parseInt((weatherData.main.temp - 273.15), 10);
  return (
    <div className='weather-content'>
      <p>{temperatureCelsius} °C</p>
    </div>
  );
};

export default Weather;
